(() => {
  if (window.bymjmGlobalReviewsStarted) return;
  window.bymjmGlobalReviewsStarted = true;
  const base = 'https://bol-mcp.mvdelzen.nl/bymjm-reviews/v1/';
  const json = async url => {
    const response = await fetch(url, {credentials: 'omit', signal: AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error('Review data unavailable');
    return response.json();
  };
  async function init(root) {
    if (root.dataset.started) return;
    root.dataset.started = 'true';
    try {
      const [summary, origins] = await Promise.all([json(base + 'summary.json'), json(root.dataset.originUrl)]);
      if (summary.review_basis !== 'all_approved_including_imports' || origins.schema_version !== 1 || !origins.matches) throw new Error('Unsupported review data');
      const url = new URL(summary.all_reviews_path, base);
      if (!url.href.startsWith(base)) throw new Error('Invalid review path');
      const result = await json(url.href);
      if (!Array.isArray(result.reviews) || result.reviews.length !== summary.total) throw new Error('Incomplete review data');
      const unique = new Map();
      for (const review of result.reviews) {
        const rating = Number(review.rating);
        if (!review.id || !['product', 'shop'].includes(review.type) || !Number.isFinite(rating) || rating < 1 || rating > 5) throw new Error('Invalid review');
        const origin = origins.matches[review.id];
        const matched = review.type === 'product' && origin && origin.date === review.date && Number(origin.rating) === rating &&
          origin.title === (review.title || '') && origin.comment === (review.comment || '');
        const id = matched ? 'original:' + origin.canonicalId : 'trusted:' + review.id;
        if (!unique.has(id)) unique.set(id, review);
      }
      const reviews = [...unique.values()];
      if (!reviews.length) return;
      const average = reviews.reduce((sum, r) => sum + Number(r.rating), 0) / reviews.length;
      const locale = root.dataset.locale || 'nl';
      const format = new Intl.NumberFormat(locale);
      const score = new Intl.NumberFormat(locale, {minimumFractionDigits:1, maximumFractionDigits:1}).format(average);
      const productCount = reviews.filter(r => r.type === 'product').length;
      const shopCount = reviews.length - productCount;
      const labels = JSON.parse(root.querySelector('[data-global-labels]').textContent);
      const summaryText = labels.summary.replaceAll('__RATING__', score).replaceAll('__COUNT__', format.format(reviews.length));
      const details = labels.details.replaceAll('__PRODUCTS__', format.format(productCount)).replaceAll('__SHOP__', format.format(shopCount));
      root.querySelector('[data-global-score]').textContent = score;
      root.querySelector('[data-global-summary]').textContent = summaryText;
      root.querySelector('[data-global-summary]').title = details;
      root.querySelectorAll('[data-global-star-stop]').forEach(stop => stop.setAttribute('offset', (average / 5 * 100) + '%'));
      root.dataset.count = String(reviews.length);
      root.dataset.productCount = String(productCount);
      root.dataset.shopCount = String(shopCount);
      root.dataset.generatedAt = summary.generated_at;
      root.dataset.loaded = 'true';
      root.hidden = false;
    } catch (error) {
      root.dataset.error = 'true';
    }
  }
  const start = () => document.querySelectorAll('[data-bymjm-global-rating]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
